/**
 * True when `value` is a non-null object, i.e. safe to index as a record.
 * The one place for this check; the type guards in src/types/* and the
 * error helpers in src/utils/apiErrors.ts build on it.
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
